export enum comparisonOperators {
    eq = 'eq', // equals(==)
    ne = 'ne', // not equals(!=)
    ge = 'ge', // greaterThanEquals(>=)
    gt = 'gt', // greaterthan(>)
    lt = 'lt', // lessthan(<)
    le = 'le', // lessthanequals(<=)
}

export interface IComparisonCondition {
    operator: comparisonOperators;
    propertyPath: string; // left operand
    right: { // right operand
        value?: any;
        toBeInferred?: boolean;
    };
}
